import { withRequestedMargins } from "./marginClampRecord";

/**
 * Fields that belong to one mounted Anbauteil rather than to what it is: its
 * identity, the Vorlage it came from, and what this particular case did to it
 * (`marginClamps`). A Vorlage must never carry them, and they never make two
 * configs different.
 */
export const VARIABLE_OPTION_INSTANCE_KEYS = [
  "uuid",
  "preset",
  "derivedFromPreset",
  "marginClamps",
] as const;

export type VariableOptionInstanceKey =
  (typeof VARIABLE_OPTION_INSTANCE_KEYS)[number];

/** A copy of `data` without the {@link VARIABLE_OPTION_INSTANCE_KEYS}. */
export function withoutVariableOptionInstanceKeys<T extends object>(
  data: T,
): Omit<T, VariableOptionInstanceKey> {
  const result = { ...data } as Record<string, unknown>;
  for (const key of VARIABLE_OPTION_INSTANCE_KEYS) {
    delete result[key];
  }
  return result as Omit<T, VariableOptionInstanceKey>;
}

/**
 * A mounted Anbauteil's data as a Vorlage stores it: every margin the case had
 * to move put back to the value that was asked for, and the instance keys
 * dropped. A Vorlage is a blueprint for other cases, so it carries the
 * request, not what one case made of it.
 */
export function presetDataFromInstance<T extends object>(
  data: T,
): Omit<T, VariableOptionInstanceKey> {
  return withoutVariableOptionInstanceKeys(withRequestedMargins(data));
}
